import React from 'react';
import PageTitle from '../../../../uiToolkit/PageTitle';
import FeedbackQuestionEditor from '../../components/FeedbackQuestionEditor';
import {FeedbackForm} from '../../feedbackForm';
import {feedbackText} from '../../feedbackText';
import styles from './CreateFeedbackUI.module.css';

interface Props {
  form: FeedbackForm;
  isSaving: boolean;
  canSave: boolean;
  hasDuplicates: boolean;
  onChange: (form: FeedbackForm) => void;
  onSave: () => void;
  onCancel: () => void;
}

const CreateFeedbackUI = React.memo(
  ({
    form,
    isSaving,
    canSave,
    hasDuplicates,
    onChange,
    onSave,
    onCancel,
  }: Props) => {
    return (
      <div className={styles.container}>
        <button className={styles.backLink} onClick={onCancel}>
          ← {feedbackText.allFeedback}
        </button>
        <PageTitle title={feedbackText.createTitle} />
        <div className={styles.editor}>
          <FeedbackQuestionEditor
            form={form}
            isSaving={isSaving}
            canSave={canSave}
            hasDuplicates={hasDuplicates}
            onChange={onChange}
            onSave={onSave}
            onCancel={onCancel}
          />
        </div>
      </div>
    );
  },
);

export default CreateFeedbackUI;
